//
//  src/components/map/Map.js
//
import React          from "react";
import GoogleMapReact from 'google-map-react';
import Logo           from "../../images/tmc.webp"
import './Map.css'


//
//  map marker.
//
const MapMarker = ({ title }) => <>
    <div className="map-marker">
        <a href="https://share.google/hrwgXEMZwKGGfdtXC">
            <img className="animate" src={ Logo } alt={ title } />
        </a>        
    </div>
</>;


//
//  map.
//
export default function Map(){

    const defaultProps = {
        center: {
            lat: -37.8550852,
            lng: 145.0183096
        },
        zoom: 16
    };

    return (
        <div className="map">
            <GoogleMapReact
                bootstrapURLKeys={{ 
                    key       : process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
                    libraries : [ 'visualization' ] 
                }}
                defaultCenter = { defaultProps.center }
                defaultZoom   = { defaultProps.zoom   }
                options = {
                    {
                    styles: [
                        {
                            featureType : "poi.business",
                            stylers : [
                              { "visibility": "off" }
                            ]
                        },
                        { 
                            stylers: [
                                { 'saturation': -100 }
                            ] 
                        }
                    ]
                }}
            >
                <MapMarker
                    lat  = { -37.8550852 }
                    lng  = { 145.0183096 }
                    text = "Compendium Tattoo"
                />
            </GoogleMapReact>
        </div>
    );

}
